// Dependencies
import { createFileRoute } from "@tanstack/react-router";
import { PageShell, PageHero } from "@/components/PageShell";
import { CategoryProductGrid } from "@/components/CategoryProductGrid";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";

// Images
import heroImage from "@/assets/hero-eletronic.png";
import daqImage from "@/assets/hero-daq.png";
import onboardImage from "@/assets/hero-onboard.png";

export const Route = createFileRoute("/$lang/category/eletronic-systems")({
  head: () => ({
    meta: [
      { title: i18n.t("category/eletronic-systems:metaTitle", "Electronic Systems & Avionics — BIZU Space") },
      {
        name: "description",
        content: i18n.t("category/eletronic-systems:metaDesc",
          "Embedded electronic systems, data acquisition (DAQ_BIZU), and onboard flight control units designed for aerospace test and qualification.",
        ),
      },
      { property: "og:title", content: i18n.t("category/eletronic-systems:metaTitle", "Electronic Systems & Avionics — BIZU Space") },
      {
        property: "og:description",
        content: i18n.t("category/eletronic-systems:metaOgDesc",
          "Developing modular electronics, sounder altimeters, telemetry beacons, and acquisition systems for rocket missions.",
        ),
      },
      { property: "og:url", content: "/category/eletronic-systems" },
    ],
    links: [{ rel: "canonical", href: "https://bizu.space/category/eletronic-systems" }],
  }),
  component: EletronicSystems,
});

function EletronicSystems() {
  const { t } = useTranslation("category/eletronic-systems");

  const products = [
    {
      name: t("daqName", "DAQ BIZU Space – Data Aquisition System"),
      link: "/products/daq",
      image: daqImage,
      buttonText: t("daqBtn", "Explore"),
    },
    {
      name: t("onboardName", "On-board components"),
      link: "/products/on-board-components",
      image: onboardImage,
      buttonText: t("onboardBtn", "Explore"),
    },
  ];

  return (
    <PageShell>
      {/* HERO SECTION */}
      <PageHero
        title={t("heroTitle", "Electronic Systems")}
        description={t("heroDesc",
          "Embedded electronic solutions and data acquisition (DAQ) systems designed for aerospace testing, qualification, and system control."
        )}
        image={heroImage}
      />
            {/* PRODUCTS SECTION */}
      <CategoryProductGrid products={products} />
    </PageShell>
  );
}
